export default __webpack_public_path__ + "static/media/csv.09c188a5.svg";